<script lang="ts">
	import sessionValues, { syncSessionValues, removeSessionValues } from "#lib/sessionValues.js";
	import { Button } from "@ishavskraft/shared";
	import { goto } from "$app/navigation";
	import { page } from "$app/state";
	import { SvelteURLSearchParams } from "svelte/reactivity";

	const removeDiscount = () => {
		// set isRemoved to true
		isRemoved = true;
		// remove mnr_type from session values
		removeSessionValues([`mnr_type`]);
		// remove mnr_type from URL
		let searchParams = new SvelteURLSearchParams(page?.url?.search || "");
		searchParams.delete("mnr_type");
		goto(`${page.url.origin}${page.url.pathname}?${searchParams.toString()}`, {
			shallow: true,
			replace: true,
			state: page.state,
		});
	};

	const activeDiscounts = [
		{
			mnr_type: "bonord",
			name: "Bonord",
			text: "og vil få 1000 kroner i rabatt ved bestilling av ferdig montert varmepumpe, og 500 kroner i rabatt ved bestilling av elbillader eller oppgradering av sikringsskap",
		},
		{
			mnr_type: "pensjonistforbundet",
			name: "Pensjonistforbundet",
			text: "og vil få 500,- i rabatt på sikringsskap og elbillader, og kr. 1500,- i rabatt på varmepumper.",
		},
	];

	interface Props {
		class?: string;
	}

	let { class: classes = "" }: Props = $props();
	let isRemoved = $state(false);

	let mnrType = $derived(!isRemoved ? $sessionValues[`mnr_type`] : null);
	let currentDiscount = $derived(
		mnrType ? activeDiscounts.find((x) => x.mnr_type === mnrType) : null
	);

	$effect(() => {
		if (mnrType && currentDiscount) {
			syncSessionValues({ mnr_type: mnrType }, { useBrowserStorage: true });
		}
	});
</script>

{#if currentDiscount || isRemoved}
	<details class="banner bg-$reinlav relative px-4 laptop:px-8 rounded-2xl {classes}">
		<summary class="py-5" aria-live="polite">
			{#if isRemoved}
				<em>Rabatt er deaktivert.</em>
			{:else if currentDiscount}
				Du bestiller nå via <strong>{currentDiscount.name}</strong> {currentDiscount.text}
			{/if}
		</summary>

		<div class="details-content py-2">
			{#if !isRemoved}
				<p>
					Dette vises fordi ishavskraft.no har registrert et medlemskap. <strong class="block"
						>Hvis dette er feil eller rabatten ikke skal være med av andre grunner:</strong
					>
				</p>
			{/if}

			<p>
				<Button class={isRemoved ? "button-disabled" : ""} onclick={removeDiscount}
					>Fjern rabatt</Button
				>
			</p>
		</div>
	</details>
{/if}
